import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  addTrainingWrapper: {
    borderRadius: 4,
    marginTop: 8,
  },
  addTrainingForm: {
    width: '100%',
  },
  createForOthersRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    minWidth: 0,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1),
    },
  },
  createForOthersToggle: {
    flexShrink: 0,
  },
  createForOthersSelectWrap: {
    flex: 1,
    minWidth: 0,
  },
  trainingHeader: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },

  trainingSetsContainer: {},

  trainingSetWrapper: {
    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.1)`,
    marginTop: theme.spacing(1),
  },
  scopeItem: {
    'li&': {
      maxWidth: 'unset',
    },
  },
  addTrainingButtonWrapper: {
    padding: theme.spacing(1),
  },
  trainerWrapper: {
    marginTop: theme.spacing(1),
  },
  trainerLabel: {
    marginLeft: theme.spacing(1),
  },
  addTrainingSetFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    padding: `${theme.spacing(1)} ${theme.spacing(1)} 0`,

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  trainingButton: {
    marginTop: 0,
    paddingTop: '8px',
  },
}));
